import * as React from 'react';
import ListOptionsCard from '../cards/ListOptionsCard';
import { ESimProfiles } from '../../reducers/user';

export interface ListIccidPageProps {
    onChange: (eSimProfiles: ESimProfiles) => void;
    eSimProfiles: ESimProfiles[];
    buttonElement: string;
    onSubmit: () => void;
    selectedEsimProfiles: ESimProfiles;
}

class ListIccidPage extends React.Component<ListIccidPageProps> {
    render() {
        return (
            <div>
                <div className="row">&nbsp;</div>
                <div className="row">
                    <div className="col-12 col-md-8">
                        <ListOptionsCard
                            listOptions={this.props.eSimProfiles}
                            onChangeEvt={this.props.onChange}
                            btnElement={this.props.buttonElement}
                            clickEvt={this.props.onSubmit}
                            selectedEsimProfiles={this.props.selectedEsimProfiles}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default ListIccidPage;



// WEBPACK FOOTER //
// ./src/components/listIccids/ListIccidPage.tsx